import produce from "immer";
import {
  GET_GROUPS_LIST,
  GET_GROUPS_LIST_SUCCESS,
  GET_GROUPS_LIST_ERROR,
  ADD_GROUP,
  ADD_GROUP_SUCCESS,
  ADD_GROUP_ERROR,
  EDIT_GROUP,
  EDIT_GROUP_SUCCESS,
  EDIT_GROUP_ERROR,
  DELETE_GROUP,
  DELETE_GROUP_SUCCESS,
  DELETE_GROUP_ERROR,
  SET_GROUPS_LIST,
  SET_GROUPS_SEARCH,
  SET_GROUPS_SORT_FIELD,
  SET_GROUPS_SORT_ORDER,
  SET_GROUPS_PAGE,
  BAN_USER_FROM_GROUP,
  BAN_USER_FROM_GROUP_SUCCESS,
  BAN_USER_FROM_GROUP_ERROR,
  UNBAN_USER_FROM_GROUP,
  UNBAN_USER_FROM_GROUP_SUCCESS,
  UNBAN_USER_FROM_GROUP_ERROR,
  GET_PINNED_GROUPS,
  GET_PINNED_GROUPS_SUCCESS,
  GET_PINNED_GROUPS_ERROR,
  SET_PINNED_GROUPS,
  SAVE_PINNED_GROUPS,
  SAVE_PINNED_GROUPS_DONE,
} from "./actionTypes";


const initialState = {
  allGroupsList: [],
  loading: false,
  error: "",
  totalCount: 0,
  totalPages: 2,
  page: 1,
  pageSize: 10,
  count: 5,
  sortOrder: "desc",
  sortField: "created_at",
  search: "",
  addGroupLoad: false,
  editGroupLoad: false,
  deleteGroupLoad: false,
  banUserLoad: false,
  unbanUserLoad: false,
  pinnedGroups: [],
  pinnedLoading: false,
  pinnedError: "",
  pinSaving: false,
};

const groupsReducer = produce((state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_GROUPS_LIST:
      return {
        ...state,
        loading: true,
      };

    case GET_GROUPS_LIST_SUCCESS:
      return {
        ...state,
        allGroupsList: payload.data,
        totalCount: payload.meta?.total || 0,
        totalPages: payload.meta?.totalPages || 0,
        limit: payload.meta?.pageSize || 5,
        count: payload.meta?.count || 0,
        loading: false,
      };

    case GET_GROUPS_LIST_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };

    // Add group
    case ADD_GROUP:
      return {
        ...state,
        addGroupLoad: true,
      };

    case ADD_GROUP_SUCCESS:
      return {
        ...state,
        addGroupLoad: false,
      };

    case ADD_GROUP_ERROR:
      return {
        ...state,
        addGroupLoad: false,
      };

    // Edit group
    case EDIT_GROUP:
      return {
        ...state,
        editGroupLoad: true,
      };

    case EDIT_GROUP_SUCCESS:
      return {
        ...state,
        editGroupLoad: false,
      };

    case EDIT_GROUP_ERROR:
      return {
        ...state,
        editGroupLoad: false,
      };

    // Delete group
    case DELETE_GROUP:
      return {
        ...state,
        deleteGroupLoad: true,
      };

    case DELETE_GROUP_SUCCESS:
      return {
        ...state,
        deleteGroupLoad: false,
      };

    case DELETE_GROUP_ERROR:
      return {
        ...state,
        deleteGroupLoad: false,
      };

    // Set groups search
    case SET_GROUPS_SEARCH:
      return {
        ...state,
        search: payload,
      };

    // Set groups sortField
    case SET_GROUPS_SORT_FIELD:
      return {
        ...state,
        sortField: payload,
      };

    // Set groups sortOrder
    case SET_GROUPS_SORT_ORDER:
      return {
        ...state,
        sortOrder: payload,
      };

    // Set groups page
    case SET_GROUPS_PAGE:
      return {
        ...state,
        page: payload,
      };

    case SET_GROUPS_LIST:
      return {
        ...state,
        allGroupsList: payload,
      };

    // Ban user from group
    case BAN_USER_FROM_GROUP:
      return { ...state, banUserLoad: true };
    case BAN_USER_FROM_GROUP_SUCCESS:
    case BAN_USER_FROM_GROUP_ERROR:
      return { ...state, banUserLoad: false };

    // Unban user from group
    case UNBAN_USER_FROM_GROUP:
      return { ...state, unbanUserLoad: true };
    case UNBAN_USER_FROM_GROUP_SUCCESS:
    case UNBAN_USER_FROM_GROUP_ERROR:
      return { ...state, unbanUserLoad: false };

    // Pinned groups
    case GET_PINNED_GROUPS:
      return { ...state, pinnedLoading: true, pinnedError: "" };
    case GET_PINNED_GROUPS_SUCCESS:
      return { ...state, pinnedLoading: false, pinnedGroups: payload };
    case GET_PINNED_GROUPS_ERROR:
      return { ...state, pinnedLoading: false, pinnedError: payload };
    case SET_PINNED_GROUPS:
      return { ...state, pinnedGroups: payload };
    case SAVE_PINNED_GROUPS:
      return { ...state, pinSaving: true };
    case SAVE_PINNED_GROUPS_DONE:
      return { ...state, pinSaving: false };

    default:
      return state;
  }
});

export default groupsReducer;
